module.exports = __webpack_public_path__ + "img/shequ5.a6759e96.png";